/* app/js/src/components/tenant/choose-template/templates-window/template-item/template-item.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.template {
  width: 450px;
  background-color: #1de9b6;
  height: 300px;
  margin: 0 10px 20px 10px;
  flex-grow: 1;
}
.template .video-player {
  width: 100%;
  height: 85%;
  position: relative;
  border: 0;
  margin-top: -1px;
}
.template .video-player video {
  width: 100%;
  height: 100%;
  float: left;
}
.template .video-player .buttons {
  visibility: hidden;
  position: absolute;
  z-index: 1;
  opacity: 0;
  width: 117px;
  margin-left: 166px;
  margin-top: 110px;
}
.template .video-player .buttons button {
  margin-bottom: 20px;
  width: 117px;
  height: 40px;
  background-color: transparent;
  border-radius: 6px;
  color: white;
  border: 1px solid white;
}
.template .video-player .buttons button:hover {
  background-color: white;
  color: #40c1fe;
}
.template .video-player:hover .buttons {
  opacity: 1;
  visibility: visible;
}
.template .video-player:hover .item-overlay {
  cursor: pointer;
  background-color: #222e39;
  width: 100%;
  height: 100%;
  opacity: 0.5;
}
.template .description-panel {
  height: 16%;
  background-color: #232f3a;
  margin-top: -1px;
}
.template .description-panel .video-title {
  color: white;
  font-size: 16px;
  font-weight: bold;
  line-height: 45px;
  text-align: left;
  padding-left: 20px;
  float: left;
  width: 240px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.template .description-panel .soundbar {
  float: right;
  display: inline-block;
  margin-top: 15px;
  width: 200px;
}
/*# sourceMappingURL=template-item.component.css.map */
